import { render, staticRenderFns } from "./DeleteBatchDialog.vue?vue&type=template&id=0f5a62f7"
import script from "./DeleteBatchDialog.vue?vue&type=script&lang=js"
export * from "./DeleteBatchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src31820908/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f5a62f7')) {
      api.createRecord('0f5a62f7', component.options)
    } else {
      api.reload('0f5a62f7', component.options)
    }
    module.hot.accept("./DeleteBatchDialog.vue?vue&type=template&id=0f5a62f7", function () {
      api.rerender('0f5a62f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DeleteBatchDialog.vue"
export default component.exports